import { SVGProps } from 'react';

const SvgHome = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12" {...props}>
        <path d="m7 1.933 3.5 3.15v5.467H9.1v-4.2H4.9v4.2H3.5V5.083L7 1.933ZM7 .05l-7 6.3h2.1v5.6h4.2v-4.2h1.4v4.2h4.2v-5.6H14" />
    </svg>
);
export default SvgHome;
